import PropTypes from 'prop-types'

export default PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
})



// WEBPACK FOOTER //
// ./src/prop-types/lead-prop-type.js